import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosGrid() {
  const bonos = [{
    num: '01',
    title: 'BONO 1 — Kit Domingo Sin Ansiedad',
    desc: 'Protocolo de 30 minutos para cerrar el domingo con calma y llegar al lunes sin colapsar.',
    val: '$15'
  }, {
    num: '02',
    title: 'BONO 2 — Checklist Anti-Papeleo MEP',
    desc: 'Sistema H/P/D/A/E para clasificar documentos en segundos y dejar de tratar todo como emergencia.',
    val: '$12'
  }, {
    num: '03',
    title: 'BONO 3 — Scripts de WhatsApp Para Padres Difíciles',
    desc: '35 mensajes listos para copiar y pegar ante reclamos, conducta, límites horarios y situaciones tensas.',
    val: '$15'
  }, {
    num: '04',
    title: 'BONO 4 — Plan de 5 Días Para Recuperar Control del Aula',
    desc: 'Acciones concretas de lunes a viernes para reinstalar orden, atención y autoridad sin gritar.',
    val: '$12'
  }, {
    num: '05',
    title: 'BONO 5 — Tracker de Burnout Docente',
    desc: 'Sistema de observación semanal para detectar señales de agotamiento antes de llegar al colapso.',
    val: '$12'
  }, {
    num: '06',
    title: 'BONO 6 — Mini Pack de Plantillas Printables Para el Aula',
    desc: '10 imprimibles listos para ordenar el aula, reducir interrupciones y comunicar instrucciones sin diseñar nada.',
    val: '$10'
  }];
  return <section className="py-20 px-4 bg-stone-100" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent-100 mb-6" data-id="element-23">
            <Gift className="w-8 h-8 text-accent-600" data-id="element-24" />
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-stone-900 mb-4" data-id="element-25">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-stone-600 font-medium uppercase tracking-wider" data-id="element-26">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-27">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 relative overflow-hidden group hover:border-accent-300 transition-colors" data-id="element-28">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-stone-50 opacity-50 group-hover:text-accent-50 transition-colors z-0" data-id="element-29">
                {bono.num}
              </div>
              <div className="relative z-10" data-id="element-30">
                <h3 className="text-lg font-bold text-stone-900 mb-3 pr-8" data-id="element-31">
                  {bono.title}
                </h3>
                <p className="text-stone-600 mb-6 text-sm leading-relaxed" data-id="element-32">
                  {bono.desc}
                </p>
                <div className="flex items-center gap-2 font-bold" data-id="element-33">
                  <span className="text-stone-400 line-through" data-id="element-34">
                    {bono.val}
                  </span>
                  <span className="text-accent-600" data-id="element-35">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-accent-500 text-white rounded-2xl p-6 text-center shadow-lg max-w-2xl mx-auto" data-id="element-36">
          <p className="text-xl md:text-2xl font-bold" data-id="element-37">
            Valor total bonos $76 USD →{' '}
            <span className="text-yellow-300" data-id="element-38">GRATIS con tu MegaPack</span>
          </p>
        </motion.div>
      </div>
    </section>;
}